<template>
  <section class="bloc-mosaic-columns">
    <div class="column-left">
      <div v-for="(row, i) in content.column_left?.rows" :key="i" class="row scroll-step js-scroll-show" :class="{ 'small' : row.small }">
        <img v-for="(img, j) in row.imgs" :key="j" class="img" :src="require(`@/${img}`)" :class="{ 'isOnly' : row.imgs.length === 1 }">
      </div>
    </div>
    <div class="column-right">
       <div v-for="(row, i) in content.column_right?.rows" :key="i" class="row scroll-step js-scroll-show" :class="{ 'small' : row.small }">
        <img v-for="(img, j) in row.imgs" :key="j" class="img" :src="require(`@/${img}`)" :class="{ 'isOnly' : row.imgs.length === 1 }">
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'MosaicColumns',
  props: {
    content: {
      type: Object,
      required: true
    },
  },
}
</script>

<style lang="scss">
  .bloc-mosaic-columns {
    width: 100vw;
    position: relative;
    z-index: 1;
    display: flex;
    justify-content: space-between;
    background: $th-white;

    .column-left,
    .column-right {
      width: calc(50% - 4px);

      @include media($from: small) {
        width: calc(50% - 8px);
      }

      .row {
        width: 100%;
        height: grid(8.5, 8);
        display: flex;
        justify-content: space-between;
        position: relative;
        margin-bottom: rem(8);

        @include media($from: small) {
          margin-bottom: rem(16);
          height: grid(9, 8);
        }

        &.small {
          height: grid(4.5, 3.5);
        }

        img {
          width: calc(50% - 4px);
          height: 100%;
          object-fit: cover;
          flex-grow: 0;

          @include media($from: small) {
            width: calc(50% - 8px);
          }

          &.isOnly {
            width: 100%;
          }
        }
      }
    }
  }
</style>
